import {memo} from 'react'

import {usePipelineId} from '../../../../hooks/pipeline'
import {getValidationErrorMessage} from '../../../../utils/validators'
import {usePipelineNameOrDraft} from '../../../EditPipelinePage.hooks'
import {pipelineDraft} from '../../../slices/EditPipelinePage.slices'
import NameSection from '../../NameSection/NameSection'

import {pipelineNameValidators} from './PipelineNameValidationError.consts'

import {useAppDispatch} from 'src/hooks/react-redux'

function PipelineName() {
  const id = usePipelineId()
  const name = usePipelineNameOrDraft()
  const dispatch = useAppDispatch()

  const validate = (value: string) => {
    const {message} = getValidationErrorMessage({
      value,
      validators: pipelineNameValidators,
    })
    return message
  }

  return (
    <NameSection
      name={name}
      aria-label={'Pipeline Name'}
      validate={validate}
      onConfirmClick={newName =>
        dispatch(pipelineDraft.actions.setPipelineName({id, name: newName}))
      }
    />
  )
}

export default memo(PipelineName)
